// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAO6ZCAPpJOLTkHjQR7nhVfV1iAbH05Asc",
  authDomain: "cheapercourse-8e692.firebaseapp.com",
  projectId: "cheapercourse-8e692",
  storageBucket: "cheapercourse-8e692.firebasestorage.app",
  messagingSenderId: "515523475471",
  appId: "1:515523475471:web:2846bf1c3926f59b604b7a",
  measurementId: "G-X879WXQKR3"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

export const auth = getAuth();

// Initialize Firebase Auth provider
const provider = new GoogleAuthProvider();
  
// whenever a user interacts with the provider, we force them to select an account
provider.setCustomParameters({   
    prompt : "select_account "
});
export const signInWithGooglePopup = () => signInWithPopup(auth, provider);

export default firebaseApp
